/**
 * Server-side device detection composable
 * Returns a fallback breakpoint based on device type during SSR phase
 * Returns undefined on client side to allow real breakpoint detection
 */
export function useServerDevice(): string | undefined {
  // On client side, return undefined to use real breakpoint detection
  if (import.meta.client) {
    return undefined;
  }

  // On server side, detect device type from User-Agent
  const device = useDevice();

  // Map device types to appropriate breakpoints
  if (device.isMobile) {
    return 'xxs'; // Mobile devices
  }

  if (device.isTablet) {
    return 'md'; // Tablet devices
  }

  if (device.isDesktop) {
    return '3xl'; // Desktop devices
  }

  // Fallback to the smallest breakpoint if device type cannot be determined
  return 'xxs';
}
